import React, { useState } from "react";
import { MdLocationPin } from "react-icons/md";
import LocationModal from "../Modals/LocationModal/LocationModal";

const CollectionMenu = () => {
  const [openLocationModal, setOpenLocationModal] = useState(false);

  const toggleLocationModal = () => {
    setOpenLocationModal(!openLocationModal);
  };

  return (

    <>

      <div className="w-full hidden relative z-10    border-1px border-red-800 lg:flex items-center shadow-lg ">

        <ul className="grow grid grid-cols-7 cursor-pointer ">
          <div className="border-2 border-transparent border-r-gray-300 cursor-pointer hover:text-sky-400">
            <button onClick={toggleLocationModal}>
              {" "}
              <center>
                <MdLocationPin /> Delivery to 400020
              </center>{" "}
            </button>
          </div>

          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/shop/grocceries"
              className="  block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Grocceries
              <div className="w-full top-10  absolute border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Fruites & Vegitables</a>
                </li>
                </a>
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Diary & Bakery</a>
                </li>
                </a>
                <a href="/shop/grocceries">
                <li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Staples</a>
                </li>
                </a>
                <a href="/shop/grocceries">
                <li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Snacks & branded food</a>
                </li>
                </a>
                <a href="/shop/grocceries">
                <li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Beverages</a>
                </li>
                </a>
                <a href="/shop/grocceries">
                <li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">
                    Personal care <br />
                    Home care
                  </a>
                </li>
                </a>
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Mom & Baby Care</a>
                </li>
                </a>
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Snacks & branded food</a>
                </li>
                </a>
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Books</a>
                </li>
                </a>
                <a href="/shop/grocceries"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/grocceries">Pets</a>
                </li>
                </a>
              </div>
            </a>
          </li>

          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/shop/homekitchen"
              className="   block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Home & Kitechen
              <div className="w-full top-10  absolute border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal   hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="">KitchenWare</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Dining</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Furnishing</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Home Decor</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Furniture</a>
                </li>
                </a> 
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Home Appliances</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Toys & Fitness</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Electrical</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Bathroom % Laundry Accessories</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Disposables</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Stationery</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Bags & Travel Luggage</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Mops, Brushes & Scrubs</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Auto Care</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Garden & Outdoor</a>
                </li>
                </a>
                 <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Pooja Needs</a>
                </li>
                </a>
              </div>
            </a>
          </li>

          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/shop/homekitchen"
              className="   block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Fashion
              <div className="w-full top-10  absolute border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Men</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Women</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Boys</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Girls</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Junior Boys</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Junior Girls</a>
                </li>
                </a>
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal hover:font-semibold hover:bg-slate-200 text-xs p-2">
                  <a href="/shop/fashion">Infants</a>
                </li>
                </a>
              </div>
       </a>
          </li>
          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/"
              className="   block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Electronics
              <div className="w-full top-10  absolute border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <a href="/shop/fashion"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="">Mobile & Tablets</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Tv & Speaker</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Home Appliances</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Computers</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Cameras</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Kitchen Appliances</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen"> Pesonal Care & Grooming </a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Smart Device</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Gaming</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Accesories</a>
                </li>
                </a>
              </div>
            </a>
          </li>

          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/"
              className="   block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Beauty
              <div className="w-full top-10  absolute border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="">Make-Up</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Hair</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Skin Care</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">GFragrances</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Personal Care</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal  hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Personal Care </a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal   hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Mom & Baby</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Men's Grooming</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Tools & Appliances</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Covid Essentials</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Wellness</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Fitness</a>
                </li>
                </a>
                <a href="/shop/homekitchen"><li className="text-black hover:text-sky-500 font-normal hover:bg-slate-200  hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Ayush</a>
                </li>
                </a>
              </div>
            </a>
          </li>

          <li className=" group relative z-10 md:border-2   py-2  border-transparent hover:border-b-red-400 text-center  border-r-gray-300">
            <a
              href="/"
              className="   block  text-black focus:text-yellow-500 "
              aria-current="page"
            >
              Jwellery
              <div className="w-full top-10  absolute   border-2 border-transparent border-t-red-400 rounded-sm bg-slate-50 z-20 hidden group-hover:block">
                <li className="text-black hover:text-sky-500 font-normal   hover:bg-slate-200 hover:font-semibold text-xs p-2">
                  <a href="/shop/homekitchen">Fine Jewellery</a>
                </li>
              </div>
            </a>
          </li>
        </ul>
      </div>

      {openLocationModal && <LocationModal closeModal={toggleLocationModal} />}
    </>
  );
};

export default CollectionMenu;
